<template>
  <el-container class="baohus" >
    <el-row :style="{'width': screenWidth+'px','height': screenHeight+'px','background-color': '#fff'}">
      <h4 style="width: 80%;text-align: left;margin-left: 10%;margin-right: 20%;margin-top: 1%;">槟榔的文化底蕴</h4>
      <p style="width: 80%;text-align: left;margin-left: 10%;margin-right: 20%;margin-top: 1%;">
      “高高的树上结槟榔，谁先采到谁先尝……”这支流传已久、脍炙人口的情歌–《采槟榔》被一代又一代俊男靓女唱着，不知打动了多少人的情怀？
      但是，真正尝过槟榔，体味槟榔文化深厚内涵的人又有几个？海南岛有椰岛之称，然而，远方的游客，当你踏上这方热土，还会看到一种与椰树相似的植物，
      她高大挺拔，不枝不蔓，通体有节，顶披羽叶，垂挂一串串葡萄般的果实，仿佛戴着美丽的桂冠……这就是充满神秘色彩的槟榔树了。据典籍记载：槟榔属棕榈科，
      热带常绿乔木，经济价值和实用价值甚高，槟榔原产于东南亚一带， 马来西亚、菲律宾、泰国均有栽培，传入中国海南已有一千多年的历史。

      </p>
      <p style="width: 80%;text-align: left;margin-left: 10%;margin-right: 20%;margin-top: 1%;">
      槟榔是海南的特产，与椰子一样代表了海南风格。海南人民在与槟榔打交道的一千多年中，不但发现槟榔是一种有名的南药，有治虫消滞、行气利水之功效。
      而且，槟榔由于她独特的作用，在海南群众生活中有特殊的地位。槟榔是海南黎、苗、汉同胞嫁娶必备礼品，男女订婚，男方必须向女方送槟榔；
      结婚时，新郎新娘要向父母和登门贺喜的亲朋敬献槟榔，表示感谢之意。说到这，就不能不说说槟榔动人的传说。相传很久很久以前，五指山下的一个黎寨里，
      住着一位名叫佰廖（黎语，意即美丽）的姑娘。她勤劳善良，心灵手巧，她织出的简裙，使美丽的孔雀都不敢开屏；她唱歌的时候，连百灵鸟都要屏息静听。

      </p>
      <p style="width: 80%;text-align: left;margin-left: 10%;margin-right: 20%;margin-top: 1%;">
      五指山下方圆几百里的青年人，都争先恐后地向她求婚。佰廖对他们说：”我不爱谁家财产，我只爱对爱情忠贞的人。如果谁把五指山顶的槟榔摘给我，谁就是我最爱的人。
      “许多求婚者听后畏怯而归。有一位名叫椰果的黎族猎手，深深地爱着佰廖，并勇敢地向五指山走去。他穿过了人迹罕至的原始森林，战服了野兽和山蚂蝗的袭击，
      终于攀上峰顶，摘回一束束槟榔果送给佰廖姑娘，与姑娘结为幸福夫妻。从那以后，当地人们便把槟榔作为定亲的信物。一旦男方看中某位姑娘，
      就要向女家送去槟榔果（俗称”放槟榔”）以示求婚。如果女方父母将赠来的槟榔盒打开，并拣一棵槟榔果来嚼，便是答应了婚事，否则便如数退还，表示推辞。
      </p>
      <p style="width: 80%;text-align: left;margin-left: 10%;margin-right: 20%;margin-top: 1%;">
      结婚时，新娘还得请双方父母和乡亲吃槟榔。黎家妇女在生下女孩时，总要在自家门前种下一株槟榔树，到女孩长大出嫁时，这株树也要随之挖出，移植到男方家，
      直到她死后才砍掉，以示其人如槟榔树一般坚贞。槟榔不仅是爱情的信物，还是敬宾待客的礼品。在海南，槟榔被视为美好、吉祥、友谊的象征。”亲朋来往非槟榔不可”。
      不论订婚、娶嫁、盖房、拜年，甚至平时走家串户，人们都要赠送槟榔或用槟榔待客。如今，槟榔正她独特的魅力潜入千家万户，构筑了颇具地方特色的槟榔文化，
      成为海南特色文化中的一朵奇葩。
      </p>


    </el-row>
  </el-container>

</template>

<script>
  export default {
    data() {
      return {

        screenWidth : window.innerWidth,
        screenHeight : window.innerHeight,

      };
    },
  }
</script>

<style>
  h2{
  		text-align: center;
  	}
  	p{
  		margin:0 0 0 25px;
  		line-height: 25px;
  	}
  	h4{
  		margin:5 0 5 0;
  	}


</style>



// WEBPACK FOOTER //
// src/components/main/binlang/2.vue